import { makeStyles } from '../../../../../styles';
export default makeStyles((theme) => ({
    container: {
        padding: theme.spacing(0, 1),
        height: 40,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    mainContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    labelContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    tooltipIcon: {
        marginLeft: theme.spacing(0.5),
        fontSize: 16,
    },
    annotation: {
        textAlign: 'left',
        color: theme.colors.gray[500],
    },
    requiredIndicator: {
        color: theme.colors.error.main,
        '&:before': {
            content: '" *"',
        },
    },
}));
//# sourceMappingURL=ColumnHeaderCell.styles.js.map